import React from "react";

const DOT_DELAYS = ["0s", "0.2s", "0.4s"];

/**
 * Shown while the image model works. Three blurred blobs drift on distinct
 * paths, so a multi-second wait reads as "something is being made" rather than
 * "stuck".
 */
export const ThumbnailGeneratingAnimation: React.FC = () => (
  <div className="relative h-full w-full overflow-hidden bg-slate-900 dark:bg-slate-950">
    <div className="absolute inset-0 blur-3xl">
      <div
        className="thumbnail-generating-blob thumbnail-generating-blob-a absolute left-[5%] top-[10%] h-3/5 w-3/5 rounded-full bg-rose-700/80"
        style={{ animationDuration: "9s" }}
      />
      <div
        className="thumbnail-generating-blob thumbnail-generating-blob-b absolute right-[5%] top-[20%] h-1/2 w-1/2 rounded-full bg-red-900/80"
        style={{ animationDuration: "12s" }}
      />
      <div
        className="thumbnail-generating-blob thumbnail-generating-blob-c absolute bottom-[5%] left-[30%] h-1/2 w-1/2 rounded-full bg-orange-800/70"
        style={{ animationDuration: "15s" }}
      />
    </div>

    <div className="absolute inset-0 flex items-center justify-center">
      <p className="flex items-baseline text-sm font-normal text-white/90">
        Generating thumbnail
        <span aria-hidden className="ml-0.5 flex">
          {DOT_DELAYS.map((delay) => (
            <span
              className="thumbnail-generating-dot"
              key={delay}
              style={{ animationDelay: delay }}
            >
              .
            </span>
          ))}
        </span>
      </p>
    </div>
  </div>
);
